import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarClock, Wrench, ClipboardCheck } from 'lucide-react';
import api from '../../services/api';
import { PageHeader, TableSkeleton, EmptyState } from '../../components/PageParts';

export default function MaintenanceCalendar() {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/maintenance-dashboard/calendar');
        setEvents(data || []);
      } finally { setLoading(false); }
    })();
  }, []);

  // Group by day
  const groups = events.reduce((acc, e) => {
    const day = (e.date || '').slice(0, 10);
    (acc[day] = acc[day] || []).push(e);
    return acc;
  }, {});
  const days = Object.keys(groups).sort();

  return (
    <div>
      <PageHeader title="Agenda de Manutenções" subtitle="Preventivas + OS agrupadas por data" />
      {loading ? <TableSkeleton rows={4} cols={2} /> :
        days.length === 0 ? <EmptyState icon={CalendarClock} title="Sem eventos" description="Cadastre planos preventivos ou crie OS para visualizá-los aqui." /> :
        <div className="space-y-4">
          {days.map(day => (
            <div key={day} className="rounded-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 overflow-hidden">
              <div className="px-4 py-3 border-b border-neutral-200 dark:border-neutral-800 bg-neutral-50 dark:bg-neutral-900/60">
                <span className="text-sm font-semibold">{new Date(day).toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })}</span>
                <span className="ml-2 text-xs text-neutral-500">({groups[day].length} evento{groups[day].length > 1 ? 's' : ''})</span>
              </div>
              <ul className="divide-y divide-neutral-100 dark:divide-neutral-800">
                {groups[day].map((e, i) => {
                  const isOs = e.kind === 'os';
                  const Icon = isOs ? Wrench : ClipboardCheck;
                  const tone = e.plan_status === 'overdue' ? 'text-red-600' : e.plan_status === 'due_soon' ? 'text-amber-600' : 'text-brand';
                  return (
                    <li key={i} className="px-4 py-3 flex items-center gap-3 hover:bg-neutral-50 dark:hover:bg-neutral-800/40 cursor-pointer" onClick={() => {
                      if (isOs) navigate(`/manutencao/os/${e.ref_id}`);
                      else navigate(`/manutencao/preventivas`);
                    }}>
                      <Icon className={`h-4 w-4 shrink-0 ${tone}`} />
                      <div className="flex-1">
                        <div className="text-sm font-medium">{e.title}</div>
                        <div className="text-xs text-neutral-500">{isOs ? `Status: ${e.os_status}` : `Preventiva ${e.plan_status || ''}`}</div>
                      </div>
                      <span className="text-xs text-neutral-500">{isOs ? 'OS' : 'Preventiva'}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
      }
    </div>
  );
}
